var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('btn',{staticClass:"mx-auto button__btn--primary button__btn--lockedWidth",attrs:{"disabled":!_vm.exerciseAllowsProceed},domProps:{"textContent":_vm._s(_vm.$t('CORE.CHECK'))},on:{"click":_vm.handleSucceedClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }